import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MobileNavService {
  showAccountSwitcher = signal<boolean>(false);
  shouldOpenMobileMenu = signal<boolean>(false);
  accountSwitcherOpenedFromDesktop = signal<boolean>(false);
  isSwitchingAccount = signal<boolean>(false);

  openAccountSwitcher(): void {
    this.showAccountSwitcher.set(true);
    this.shouldOpenMobileMenu.set(true);
    this.accountSwitcherOpenedFromDesktop.set(true);
  }

  openAccountSwitcherFromNav(): void {
    this.showAccountSwitcher.set(true);
    this.accountSwitcherOpenedFromDesktop.set(false);
  }

  closeAccountSwitcher(): void {
    this.showAccountSwitcher.set(false);
    this.accountSwitcherOpenedFromDesktop.set(false);
  }

  resetShouldOpenFlag(): void {
    this.shouldOpenMobileMenu.set(false);
  }
}
